export default __webpack_public_path__ + "static/media/man_typen_final_img.65d99d27.jpg";